import React from 'react';
import { Flex } from '@chakra-ui/react';
import { coverageTypeEnum } from 'common/utils/enums';
import CoverageTypeCard from './coverage-type-card';

const CoverageTypeSelector = ({
  planData,
  selectedType,
  onTypeChange,
  isLimitedCoverageAvailable,
  limitedCoverageData,
  fullCoverageData,
}) => {
  if (
    !isLimitedCoverageAvailable ||
    !limitedCoverageData ||
    !fullCoverageData
  ) {
    return null;
  }

  const lease = planData?.lease;

  return (
    <Flex className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      {/* Limited Coverage Card */}
      <CoverageTypeCard
        type={coverageTypeEnum.LIMITED}
        coverageData={limitedCoverageData}
        isSelected={selectedType === coverageTypeEnum.LIMITED}
        onSelect={onTypeChange}
        lease={lease}
      />

      {/* Full Coverage Card */}
      <CoverageTypeCard
        type={coverageTypeEnum.FULL}
        coverageData={fullCoverageData}
        isSelected={selectedType === coverageTypeEnum.FULL}
        onSelect={onTypeChange}
        lease={lease}
      />
    </Flex>
  );
};

export default CoverageTypeSelector;
